import { useNavigate } from "react-router-dom";
import './Styles.css';
import {Button} from '@mui/material';
import React, { useState } from "react";
import ApiConfig from '../../../utils/services/apiConfig'
import { useKeycloak } from '@react-keycloak/web';
import Box from '@mui/material/Box';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useMountEffect } from '../../../utils/hooks';



function AIManagement() {
  // console.log(robotSelectedAI);

  const navigate = useNavigate();
  const [robots, setRobots] = useState([]);
  const [aiobjects, setAIObjects] = useState([]);
  const [robotSelectedAI, setRobotSelectedAI] = useState({});
  const { keycloak } = useKeycloak();
  const a = new ApiConfig(keycloak)
  const apiConfig = a.api()

  const handleBackClick = () => {
    navigate(-1); // Navigate back to the previous page
  };


  const initRetrieve = () => {
    Promise.all([
        apiConfig.fetchAllAIObjects(),
        apiConfig.fetchRobotData(0),
        apiConfig.fetchAllAIConfigs(),
    ]).then(results => {
        setAIObjects(results[0].RobotResponse);
        setRobots(results[1].RobotResponse);
        const formattedSelectedAIObject = {};
        results[2].RobotResponse.forEach(item => {
            var robotAIObject = null
            results[0].RobotResponse.forEach(ai => {
              if(String(ai.Id) === String(item.RobotAIObjectId)){
                robotAIObject = ai
              }
            });
            if (!formattedSelectedAIObject[item.RobotTableId]) {
              formattedSelectedAIObject[item.RobotTableId] = [robotAIObject.ObjectClass];
            } else {
              formattedSelectedAIObject[item.RobotTableId].push(robotAIObject.ObjectClass);
            }
        });
        console.log(formattedSelectedAIObject);
        setRobotSelectedAI(formattedSelectedAIObject);
    }).catch(error => {
        console.error(error);
    });
  }

  useMountEffect(() => {
    initRetrieve()
  }, []);

  const handleManageRobot = (robot) => {
    navigate(`/managements/ai_management/${robot.RobotId}`, { state: {aiobjects: aiobjects, robotSelectedAI: robotSelectedAI} })
  };

  return (
    <div className='robotFullContainer'>

      <h1>AI Management
      <Box
  sx={{
    paddingRight: '20px',         // Default padding for small screens
    display: 'flex',
    justifyContent: 'flex-end',    // Align to the right
    '@media (min-width: 768px)': {
      paddingRight: '40px',        // Increase right padding for tablet screens
    },
    '@media (min-width: 1024px)': {
      paddingRight: '40px',        // Same right padding for larger screens
    },
  }}
>
  <Button
    onClick={handleBackClick}
    variant="contained"
    startIcon={<ArrowBackIcon />}
    sx={{
      fontSize: '16px',
      padding: '10px 20px',
      borderRadius: '8px',
      '&:hover': {
        transform: 'scale(1.05)',
      },
      transition: 'all 0.3s ease-in-out',
      width: 'auto',
      '@media (max-width: 480px)': {
        width: '100%',              // Full width for small screens
        fontSize: '14px',
      },
    }}
  >
    Back to Previous Page
  </Button>
</Box>
       </h1>

      <div className="robotContainer">
        {robots.map((robot) => (
          <div className="robotButton">
          <Button key={robot.Id} onClick={()=>{handleManageRobot(robot)}} variant="contained" className="robotButtonContent">
            <Robot name={robot.RobotId} robotSelectedAI={robotSelectedAI[robot.Id] || []} />
          </Button>
          </div>
        ))
        }
      </div>
    </div>
  );
}




function Robot({ name, robotSelectedAI}) {
  // console.log(robotSelectedAI);

  return (
    <div className="robotButtonContent" key={name}>
      <div className='robotName'>Robot {name}</div>
      <div className='robotSelectedAI'>
        {Object.keys(robotSelectedAI).length > 0
          ? "Selected AI: " + robotSelectedAI.join(", ")
          : "No AI selected"}
      </div>
    </div>
  );
}
export default AIManagement;